<template>
  <div>
    <app-header></app-header>
    <banner></banner>
    <component :is="switchTheme()"></component>
    <app-footer></app-footer>

    <!-- 防诈骗悬浮 -->
    <div v-if="secure" class="model-box">
      <div class="guard-against">
        <div class="center">
          <img :src="secureImg" alt="" />
        </div>
        <div class="on-button" :class="{ 'btn-blue': !isRemindTime }">
          <div class="btn-left" @click="noRemind">3天内不再提醒</div>
          <div class="btn-right" @click="close">关闭</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../components/common/AppHeader";
import AppFooter from "../components/common/AppFooter";
import Banner from "../components/home/Banner";
import ThemeInformation from "../components/home/ThemeInformation";
import ThemeProduct from "../components/home/ThemeProduct";
import ThemeService from "../components/home/ThemeService";
import ThemeSynth from "../components/home/ThemeSynth";
import ThemeSynthFresh from "../components/home/ThemeSynthFresh";

import { siteMixin } from "../utils/mixin";
export default {
  name: "Home",
  mixins: [siteMixin],
  data() {
    return {
      information: ThemeInformation,
      product: ThemeProduct,
      service: ThemeService,
      synth: ThemeSynth,
      fresh: ThemeSynthFresh,
      secure: false,
    };
  },
  computed: {
    isRemindTime() {
      const now = new Date().getTime();
      const targetTime = new Date("2026/04/26 09:00:00").getTime();
      return now >= targetTime;
    },
    secureImg() {
      if (this.isRemindTime) {
        return require("../assets/images/remind.png");
      } else {
        return require("../assets/images/shutdown.png");
      }
    },
  },

  beforeMount() {
    //定制化跳转,当前机构不需要首页，进入直接跳到登录页
    if (this.$customIds.includes(this.siteConfig.agencyId)) {
      location.href = "/login";
    }
  },
  mounted() {
    this.setMetaData("首页");
    this.isRemindFn();
  },
  components: {
    AppHeader,
    AppFooter,
    Banner,
  },
  methods: {
    /**
     * 是否提醒防诈弹窗
     */
    isRemindFn() {
      const data = new Date().getTime();
      const endRemindDays = localStorage.getItem("endRemindDays");
      // 未过设置有效期
      if (endRemindDays && endRemindDays >= data) {
        return;
      }
      this.secure = true;
    },
    /**
     * 3天不再提醒
     */
    noRemind() {
      const data = new Date().getTime() + 259200000; // 3天后时间戳
      localStorage.setItem("endRemindDays", data);
      this.secure = false;
    },
    /**
     * 关闭今日提醒 设置时间为当天的23:59:59
     */
    close() {
      const now = new Date();
      const endOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23,
        59,
        59,
        999,
      ).getTime();
      localStorage.setItem("endRemindDays", endOfDay);
      this.secure = false;
    },
    switchTheme() {
      switch (this.siteConfig.theme) {
        case "information":
          return this.information;
          break;
        case "product":
          return this.product;
          break;
        case "service":
          return this.service;
        case "overall":
          return this.synth;
        case "fresh":
          return this.fresh;
        default:
          return this.product;
          break;
      }
      return this.product;
    },
  },
};
</script>

<style lang="less" scoped>
.model-box {
  display: flex; /* 添加 Flexbox 布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  .guard-against {
    width: 579px;
    height: fit-content;
    .center {
      width: 576px;
      height: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .shutdown-img {
      display: block;
      width: 576px;
      height: auto;
      object-fit: contain;
      margin-left: 8px;
    }
    .on-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 80px;
      // background-color: #fff;
      div {
        width: 146px;
        height: 40px;
        line-height: 40px;
        border-radius: 37px;
        text-align: center;
        cursor: pointer;
      }
      .btn-left {
        margin-right: 16px;
        color: #e43729;
        font-size: 16px;
        border: 1px solid #e43729;
        background-color: #fff;
      }
      .btn-right {
        color: #fff;
        background: linear-gradient(95deg, #ea2c14 6.61%, #d70f0a 92.45%);
      }
    }
    .btn-blue {
      .btn-left {
        color: #e6e6e6f2;
        border-color: #e6e6e6;
        background: transparent;
      }
      .btn-right {
        background: #ffffff;
        color: #0e2a83;
      }
    }
  }
}
</style>
